<template>
    <v-card
        width="100%"
        color="white"
        class="pt-4"
    >
        <section-heading
            title="Our Sweets"
            color="primary"
        ></section-heading>
        <v-container :fluid="$vuetify.breakpoint.mdAndDown">
            <v-row dense justify="center">
                <v-col cols="12" md="8" class="text-center">
                    <span style="color: var(--v-primary-base)">
                        Crafted to perfection, our confectionaries are whole food based and always sugar and gluten-free.
                    </span>
                </v-col>
            </v-row>
            <v-row dense class="mt-4">
                <v-col cols="12" sm="6" md="2">
                    <v-select
                        label="Sort By"
                        :items="sortOptions"
                        v-model="selectedProductSort"
                        hide-details
                        outlined
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-menu
                        offset-y
                        :close-on-content-click="false"
                        v-model="filters"
                    >
                        <template v-slot:activator="{on}">
                            <v-combobox
                                label="Filter Products"
                                hide-details
                                outlined
                                v-on="on"
                                readonly
                                :value="filterChips"
                                class="product-filter-dropdown"
                            >
                                <template v-slot:selection>
                                    <div
                                        v-for="(filter, i) in filterChips"
                                        :key="i"
                                    >
                                        <v-chip
                                            color="primary"
                                            small
                                            close
                                            v-if="i < 2"
                                            @click:close="removeFilterChip(filter)"
                                        >
                                            <span>{{filter.text}}</span>
                                        </v-chip>
                                    </div>
                                    <div >
                                        <small v-on="on" v-if="filterChips.length === 0">No filters applied.</small>
                                        <small v-on="on" v-else-if="filterChips.length > 2">+ <span v-text="filterChips.length - 2"></span></small>
                                    </div>
                                </template>
                            </v-combobox>
                        </template>
                        <v-card
                            min-height="100"
                            min-width="400"
                            tile
                            elevation="10"
                        >
                            <v-btn
                                x-small
                                icon
                                absolute
                                top
                                right
                                @click="filters = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title class="primary-text font-weight-bold">
                                Product Filters
                            </v-card-title>
                            <v-card-text class="d-flex flex-row">
                                <div>
                                    <span class="subtitle">Product Category</span>
                                    <v-checkbox
                                        v-for="(category, i) in categories"
                                        v-model="selectedProductCategoryFilter"
                                        :label="category"
                                        :value="category"
                                        :key="i"
                                        hide-details
                                        dense
                                        class="filter-check"
                                    ></v-checkbox>
                                </div>
                                <div class="ml-10">
                                    <span class="subtitle">Product Attributes</span>
                                    <v-checkbox
                                        v-for="(attribute, i) in attributes"
                                        :label="getDisplayName(attribute)"
                                        v-model="selectedProductAttributeFilter"
                                        :value="attribute"
                                        :key="i"
                                        hide-details
                                        dense
                                        class="filter-check"
                                    ></v-checkbox>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    text
                                    color="error"
                                    small
                                    @click="clearFilter"
                                >
                                    clear filters
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                        label="Search Products"
                        prepend-inner-icon="mdi-magnify"
                        hide-details
                        outlined
                        v-model="typedSearchText"
                        clearable
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import SectionHeading from "../SectionHeading";
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        name: "ProductFilterBar",
        components: {
            SectionHeading
        },
        data(){
            return {
                sortOptions: [
                    'A-Z',
                    'Z-A',
                    'Price: Low to High',
                    'Price: High to Low'
                ],
                filters: false
            }
        },
        methods: {
            ...mapMutations(['setProductSort', "setProductCategoryFilter", "setProductAttributeFilter", "setProductSearchText"]),
            getDisplayName(attribute){
                let parts = attribute.split('-');
                let newParts = [];
                parts.forEach(part => {
                    let newPart = part[0].toUpperCase() + part.slice(1);
                    newParts.push(newPart)
                });
                return newParts.join(' ');
            },
            clearFilter(){
                this.selectedProductCategoryFilter = [];
                this.selectedProductAttributeFilter = [];
            },
            removeFilterChip(item){
                if(item.type === 'category'){
                    this.selectedProductCategoryFilter.splice(this.selectedProductCategoryFilter.indexOf(item.value), 1)
                } else if(item.type === 'attribute'){
                    this.selectedProductAttributeFilter.splice(this.selectedProductAttributeFilter.indexOf(item.value), 1)
                }
            }
        },
        computed: {
            ...mapState(["productSort", "productCategoryFilter", "productAttributeFilter", "productSearchText"]),
            ...mapGetters(["categories", "attributes"]),
            selectedProductSort: {
                get(){
                    return this.productSort
                },
                set(value){
                    this.setProductSort(value)
                }
            },
            selectedProductCategoryFilter: {
                get(){
                    return this.productCategoryFilter
                },
                set(value){
                    this.setProductCategoryFilter(value)
                }
            },
            selectedProductAttributeFilter: {
                get(){
                    return this.productAttributeFilter
                },
                set(value){
                    this.setProductAttributeFilter(value)
                }
            },
            typedSearchText: {
                get(){
                    return this.productSearchText
                },
                set(text){
                    if(text === null){
                        text = '';
                    }
                    this.setProductSearchText(text)
                }
            },
            filterChips(){

                let chips = [];
                this.selectedProductCategoryFilter.forEach(category => {
                    chips.push({type: 'category', text: category, value: category})
                });

                this.selectedProductAttributeFilter.forEach(attribute => {
                    chips.push({type: 'attribute', text: this.getDisplayName(attribute), value: attribute})
                });

                return chips

            }
        }
    }
</script>

<style scoped>
.filter-check{
    margin-top: 0;
}

.product-filter-dropdown >>> * {
    cursor: pointer !important;
}
</style>